import { HttpClient } from '@angular/common/http';
import { Inject, LOCALE_ID, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { Menu, setMenu } from '../store';

@Injectable({ providedIn: 'root' })
export class MenuService {
  constructor(@Inject(LOCALE_ID) public localeID: string, private http: HttpClient, private store: Store) {}

  getMenu() {
    return this.http.get<Menu[]>(`assets/i18n/${this.localeID}/menu.json`).pipe(
      map(menu => {
        this.store.dispatch(setMenu({ menu }));
        return menu;
      })
    );
  }
}
